export default __webpack_public_path__ + "static/media/imprint-data-policy-4k.0b3599df.jpg";